
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  ref,
  toRef,
  watch,
} from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { INNER_PAGE_ROWS_PER_PAGE, PAGINATION } from "@/helpers/pagination";
import { FormatMethods } from "@/helpers/data-format";
import { UserAPI } from "@/services/api/User.service";
import {
  userActivityTableHeaders,
  userActivityTableFilters,
} from "../dataTableOptions";
import { IUserActivity, IUser } from "@/interfaces/iUser";
import { IDataTableFilterOption } from "@/interfaces/iPageModel";

export default defineComponent({
  name: "UserActivity",
  props: {
    data: { type: Object as PropType<IUser>, required: true },
    isActive: { type: Boolean, default: false },
  },
  components: { Datatable },
  setup(props) {
    const dataProp = toRef(props, "data");
    const localPagination = reactive({ ...PAGINATION });
    const rowsPerPage = ref(INNER_PAGE_ROWS_PER_PAGE);
    const loading = ref(false);
    const showSearch = true;
    const tableData = ref<IUserActivity[]>([]);
    const tableHeader = ref(userActivityTableHeaders());
    const Datatable = ref();
    const tableFilter = ref<Array<IDataTableFilterOption>>(
      userActivityTableFilters()
    );
    const format = computed(() => FormatMethods);

    const syncQuery = async (params?: Record<string, number | string>) => {
      await queryUpdate(dataProp.value.webId, params);
    };

    const queryUpdate = async (entityId: number, params?: any) => {
      try {
        loading.value = true;
        if (!params || !params.sort) {
          params = {
            ...params,
            sort: "createdDate,desc",
            startDate: params?.startDate === null ? [] : params?.startDate,
          };
        }
        const data = await UserAPI.getInstance().getUserActivity({
          ...params,
          entityId,
        });
        tableData.value = [...data.content];
        localPagination.total = data.totalElements;
        localPagination.page = data.number + 1;
        rowsPerPage.value = data.size;
      } finally {
        loading.value = false;
      }
    };

    const updateRowsPerPage = (newSize: number) => {
      rowsPerPage.value = newSize;
      syncQuery({
        page: 0,
        size: newSize,
      });
    };

    const updatePage = (newPage: number) => {
      localPagination.page = newPage;
      syncQuery({
        page: newPage - 1,
        size: rowsPerPage.value,
      });
    };
    // const observeClickOnClass = () => {
    //   document.body.addEventListener("click", (event) => {
    //     const clickedElement = event.target as HTMLElement;

    //     if (clickedElement.tagName === "SPAN") {
    //       const innerHtmlContent = clickedElement.innerHTML;

    //       const tempElement = document.createElement("div");
    //       tempElement.innerHTML = innerHtmlContent;

    //       // Extract the text content from the parsed HTML
    //       const textContent = tempElement.textContent?.trim();
    //       if (textContent === "Activity Pulse") {
    //         syncQuery({
    //           page: 0,
    //           size: INNER_PAGE_ROWS_PER_PAGE,
    //         });
    //       }
    //     }
    //   });
    // };

    // observeClickOnClass();
    // watch(
    //   dataProp,
    //   (newValue) => {
    //     tableData.value = [];
    //     rowsPerPage.value = INNER_PAGE_ROWS_PER_PAGE;
    //     queryUpdate(+newValue.webId, {
    //       page: localPagination.page - 1,
    //       size: rowsPerPage.value,
    //     });
    //     if (Datatable.value?.VZFilter) {
    //       Datatable.value.VZFilter.getSavedFilterList();
    //     }

    //     // }
    //   },
    //   { deep: true }
    // );

    onMounted(() => {
      loading.value = true;
    });
    watch(
      () => props.isActive,
      async (isActive) => {
        if (isActive && dataProp.value.webId) {
          loading.value = true;
          if (Datatable.value?.VZFilter) {
            await Datatable.value.VZFilter.getAppliedFilters();
          }
        } else {
          tableData.value = [];
        }
      }
    );

    return {
      format,
      tableData,
      tableHeader,
      tableFilter,
      showSearch,
      rowsPerPage,
      loading,
      syncQuery,
      updateRowsPerPage,
      updatePage,
      localPagination,
      Datatable,
    };
  },
});
